import moment from 'moment';
import { numberWithCommas } from './DataFormatterUtils';

// Comma-groups a reading for display, dropping float noise and rendering non-numbers as blank.
export const formatMeterReadingValue = (value: any): string => {
	if (value === null || value === undefined || String(value).trim() === '') {
		return '';
	}
	const parsedValue = Number(value);
	if (!isFinite(parsedValue)) {
		return '';
	}
	const [integerPart, decimalPart] = String(Number(parsedValue.toFixed(10))).split('.');
	const integerWithCommas = numberWithCommas(integerPart);
	return decimalPart === undefined ? integerWithCommas : `${integerWithCommas}.${decimalPart}`;
};

// Readings as a plottable series: values coerced to numbers, unplottable ones dropped, sorted by time.
export const getMeterReadingsChartSeries = (meterReadings: any[]): any[] =>
	(meterReadings || [])
		.map((reading) => {
			const strippedValue = String(reading.value).replace(/[,\s]/g, '');
			return { ...reading, value: strippedValue === '' ? NaN : Number(strippedValue) };
		})
		.filter((reading) => isFinite(reading.value) && !!reading.recordedAt)
		.sort(
			(firstReading, secondReading) =>
				moment(firstReading.recordedAt).valueOf() - moment(secondReading.recordedAt).valueOf()
		);
